import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navItems = [
  { name: '首页', path: '/', icon: 'ri-home-4-line' },
  { name: '分类浏览', path: '/category/story', icon: 'ri-grid-line' },
  { name: '排行榜', path: '/', hash: 'ranking', icon: 'ri-medal-line' },
  { name: '文章推荐', path: '/', hash: 'articles', icon: 'ri-article-line' },
  { name: '关于我们', path: '/about', icon: 'ri-information-line' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap cursor-pointer">
            <span className={`font-heading text-xl md:text-2xl transition-colors duration-300 ${
              scrolled ? 'text-primary-500' : 'text-background-50'
            }`}>
              动漫精选
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {navItems.map((item) => {
              const isActive = location.pathname === item.path && !item.hash;
              return item.hash ? (
                <a
                  key={item.name}
                  href={`${item.path}#${item.hash}`}
                  className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
                    scrolled
                      ? 'text-foreground-700 hover:text-primary-500 hover:bg-primary-50'
                      : 'text-background-50/80 hover:text-background-50 hover:bg-white/10'
                  }`}
                >
                  {item.name}
                </a>
              ) : (
                <Link
                  key={item.name}
                  to={item.path}
                  className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
                    isActive
                      ? scrolled
                        ? 'bg-primary-500 text-background-50'
                        : 'bg-white/20 text-background-50'
                      : scrolled
                        ? 'text-foreground-700 hover:text-primary-500 hover:bg-primary-50'
                        : 'text-background-50/80 hover:text-background-50 hover:bg-white/10'
                  }`}
                >
                  {item.name}
                </Link>
              );
            })}
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg transition-colors duration-200 cursor-pointer ${
              scrolled ? 'text-foreground-900' : 'text-background-50'
            }`}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-3 flex flex-col gap-1">
            {navItems.map((item) => {
              const isActive = location.pathname === item.path && !item.hash;
              return item.hash ? (
                <a
                  key={item.name}
                  href={`${item.path}#${item.hash}`}
                  className="flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-medium text-foreground-700 hover:bg-primary-50 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer"
                >
                  <i className={item.icon}></i>
                  {item.name}
                </a>
              ) : (
                <Link
                  key={item.name}
                  to={item.path}
                  className={`flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                    isActive
                      ? 'bg-primary-500 text-background-50'
                      : 'text-foreground-700 hover:bg-primary-50 hover:text-primary-500'
                  }`}
                >
                  <i className={item.icon}></i>
                  {item.name}
                </Link>
              );
            })}
          </div>
        </div>
      )}
    </nav>
  );
}